var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Complete_Icon",
    transform: "translate(-1440 -167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11458",
    "data-name": "Group 11458",
    transform: "translate(1440 167)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_993",
    "data-name": "Ellipse 993",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(0 0)",
    fill: "#243746"
  })), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M10.293,19.382a1.375,1.375,0,0,1-1.112-.576L5.606,13.887a1.49,1.49,0,0,1,.27-2.033,1.357,1.357,0,0,1,1.954.281l2.353,3.233L16.1,5.481a1.365,1.365,0,0,1,1.923-.464,1.487,1.487,0,0,1,.447,2L11.479,18.7a1.382,1.382,0,0,1-1.121.684c-.022,0-.042,0-.064,0Z",
    transform: "translate(1447.999 174.91)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/Complete_Icon.1f5cb91f.svg";
export { ForwardRef as ReactComponent };